import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=5ddf2b67&scoped=true"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"
import style0 from "./Home.vue?vue&type=style&index=0&id=5ddf2b67&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddf2b67",
  null
  
)

export default component.exports